export default __webpack_public_path__ + "static/hover12-8ac927f7ae3233ba1f534ed7210b0f4b.png";